import axios from '../../plugins/axios.js';

export default{
    async getBlockedAndWhitelistNumbers() {
        return await axios.get('/api/PhoneNumberRepository/GetBlockedAndWhitelistNumbers');
      },
      async deleteBlockedOrWhitelistNumber(blockedOrWhiteListValues) {
        return await axios.post('/api/PhoneNumberRepository/DeleteBlockedOrWhitelistNumber', blockedOrWhiteListValues);
      },
      async saveBlockedOrWhitelistNumber(blockedOrWhitelistNumberData) {
        return await axios.post('/api/PhoneNumberRepository/UpsertBlockedOrWhitelistNumber',blockedOrWhitelistNumberData);
      },
}